import type { Id } from '@e-socna/data-layer';

import type { MissionReportPage_OneReport } from '../../../pages/MissionReport/hooks/useFindOneReportQuery.hook';
import type { MissionReportPage_ReportInfo } from '../../../pages/MissionReport/fragments/report-info.fragment';

export enum ReportContextStatus {
  Loading = 'loading',
  NotInitialized = 'notInitialized',
  Ready = 'ready',
  Error = 'error',
}

interface ReportContextLoading {
  readonly status: ReportContextStatus.Loading;
  readonly missionReportId: undefined;
  readonly missionReport: undefined;
  readonly missionReportInfo: undefined;
}

interface ReportContextNotInitialized {
  readonly status: ReportContextStatus.NotInitialized;
  readonly missionReportId: undefined;
  readonly missionReport: undefined;
  readonly missionReportInfo: undefined;
}

interface ReportContextReady {
  readonly status: ReportContextStatus.Ready;
  readonly missionReportId: Id;
  readonly missionReport: MissionReportPage_OneReport;
  readonly missionReportInfo: MissionReportPage_ReportInfo;
}

interface ReportContextError {
  readonly status: ReportContextStatus.Error;
  readonly missionReportId: undefined;
  readonly missionReport: undefined;
  readonly missionReportInfo: undefined;
}

export type ReportContextData =
  | ReportContextLoading
  | ReportContextNotInitialized
  | ReportContextReady
  | ReportContextError;
